import './App.css';
import Router from './features'
function App() {

  return <Router/>;
}

export default App;
